import Axios from 'axios'

const montarFiltroParams = (filtros = []) => {
  const filtroParams = {}

  if (filtros && Array.isArray(filtros)) {
    filtros.forEach(filtro => {
      if (filtro.column === 'dt_criacao_inicial' && typeof filtro.value === 'object') {
        filtroParams.dt_criacao_inicial = JSON.stringify(filtro.value)
      } else {
        filtroParams[filtro.column] = filtro.value
      }
    })
  }

  return filtroParams
}

export default {
  /**
   * @param {object} params
   * @returns {Promise}
   */
  get: (params = {}) => Axios.get('/chamados', { params }),

  /**
   * @param {object} chamadoData
   * @returns {Promise}
   */
  novoChamado: chamadoData => {
    const formData = new FormData()

    formData.append('id_categoria', chamadoData.id_categoria)
    formData.append('titulo', chamadoData.titulo)
    formData.append('descricao', chamadoData.descricao)
    const empresas = (chamadoData.empresas || []).map(empresa => {
      if (typeof empresa === 'object' && empresa.id_empresa) {
        return empresa.id_empresa
      }
      return empresa
    })
    formData.append('empresas', JSON.stringify(empresas))

    if (chamadoData.anexos && chamadoData.anexos.length > 0) {
      for (const anexo of chamadoData.anexos) {
        formData.append('anexos', anexo)
      }
    }

    return Axios.post('/chamados', formData)
  },

  /**
   * @returns {Promise}
   */
  listarCategorias: () => Axios.get('/chamados/categorias'),

  /**
   * @returns {Promise}
   */
  listarProfissionais: () => Axios.get('/chamados/profissionais'),

  /**
   * @param {number} page
   * @param {number} perPage
   * @param {Array} filtros
   * @param {object} options
   * @param {boolean} mostrarResolvidos
   * @returns {Promise}
   */
  listarChamados: (page, perPage, filtros, options, mostrarResolvidos) => {
    const paramsReservados = ['page', 'perPage', 'sortBy', 'sortOrder', 'sortDesc', 'mostrarResolvidos', 'mostrarFinalizados']
    const filtroParams = {}
    if (filtros && Array.isArray(filtros)) {
      filtros.forEach(filtro => {
        if (paramsReservados.includes(filtro.column)) return
        if (filtro.column === 'dt_criacao_inicial' && typeof filtro.value === 'object') {
          filtroParams.dt_criacao_inicial = JSON.stringify(filtro.value)
        } else {
          filtroParams[filtro.column] = filtro.value
        }
      })
    }

    const safeOptions = options || {}
    const { sortDesc, sortBy } = safeOptions

    const colunaOrdenacao = sortBy && sortBy[0] ? sortBy[0] : null
    const ordenacaoParams = colunaOrdenacao
      ? { sortBy: colunaOrdenacao, sortOrder: sortDesc && sortDesc[0] ? 'desc' : 'asc' }
      : {}

    const { itemsPerPage } = safeOptions
    const perPageFinal = itemsPerPage || perPage

    return Axios.get('/chamados', {
      params: {
        ...filtroParams,
        page,
        perPage: perPageFinal,
        ...ordenacaoParams,
        mostrarResolvidos,
      },
    })
  },

  /**
   * @param {number} id
   * @returns {Promise}
   */
  buscarPorId: id => Axios.get(`/chamados/${id}`),

  /**
   * @param {number} chamadoId
   * @param {object} mensagemData
   * @returns {Promise}
   */
  adicionarMensagem: (chamadoId, mensagemData) => {
    const formData = new FormData()
    formData.append('mensagem', mensagemData.mensagem)

    if (mensagemData.anexos && mensagemData.anexos.length > 0) {
      for (const anexo of mensagemData.anexos) {
        formData.append('anexos', anexo)
      }
    }

    return Axios.post(`/chamados/${chamadoId}/mensagens`, formData)
  },

  /**
   * @param {number} chamadoId
   * @returns {Promise}
   */
  fecharChamado: chamadoId => Axios.post(`/chamados/${chamadoId}/fechar`),

  /**
   * @param {number} chamadoId
   * @returns {Promise}
   */
  resolverChamado: chamadoId => Axios.post(`/chamados/${chamadoId}/resolver`),

  /**
   * @param {number} chamadoId
   * @returns {Promise}
   */
  reabrirChamado: chamadoId => Axios.post(`/chamados/${chamadoId}/reabrir`),

  /**
   * @param {number} chamadoId
   * @returns {Promise}
   */
  reabrirComoNovo: chamadoId => Axios.post(`/chamados/${chamadoId}/reabrir-vinculado`),

  /**
   * @param {number} chamadoId
   * @param {object} data
   * @returns {Promise}
   */
  gerenciarParticipantes: (chamadoId, data) => Axios.post(`/chamados/${chamadoId}/participantes`, data),

  /**
   * @param {number} chamadoId
   * @param {number} categoriaId
   * @returns {Promise}
   */
  redirecionarChamadoCategoria: (chamadoId, categoriaId) =>
    Axios.post(`/chamados/${chamadoId}/redirecionar`, { categoriaId }),

  /**
   * @param {number} chamadoId
   * @returns {Promise}
   */
  buscarVinculos: chamadoId => Axios.get(`/chamados/${chamadoId}/vinculos`),

  /**
   * @param {number} chamadoId
   * @param {number[]} chamadosVinculados
   * @returns {Promise}
   */
  salvarVinculos: (chamadoId, chamadosVinculados) =>
    Axios.post(`/chamados/${chamadoId}/vinculos`, { chamados: chamadosVinculados }),

  /**
   * @returns {Promise}
   */
  getCategoriasOwners: () => Axios.get('/chamados/categorias-owners'),

  /**
   * @param {number} chamadoId
   * @param {string} prioridade
   * @returns {Promise}
   */
  atualizarPrioridade: (chamadoId, prioridade) => Axios.put(`/chamados/${chamadoId}/prioridade`, { prioridade }),

  /**
   * Busca as quantidades dos cards de indicadores do topo da listagem.
   * @param {Array} filtros
   * @returns {Promise}
   */
  buscarIndicadores: (filtros = []) => Axios.get('/chamados/indicadores', { params: montarFiltroParams(filtros) }),

  /**
   * @param {Array} filtros
   * @returns {Promise}
   */
  verificarChamadosSemMovimentacao: (filtros = []) => {
    const filtroParams = {}
    if (filtros && Array.isArray(filtros)) {
      filtros.forEach(filtro => {
        if (filtro.column === 'dt_criacao_inicial' && typeof filtro.value === 'object') {
          filtroParams.dt_criacao_inicial = JSON.stringify(filtro.value)
        } else {
          filtroParams[filtro.column] = filtro.value
        }
      })
    }

    return Axios.get('/chamados/sem-movimentacao', { params: filtroParams })
  },
}
